module.exports = __webpack_public_path__ + "assets/images/screenshot-b431b96f539fe4e2f1308935f195800f.png";